export const Barcode = `<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M3 6V28" stroke="currentColor" stroke-width="2" stroke-linejoin="round"/>
<path d="M29 6V28" stroke="currentColor" stroke-width="2" stroke-linejoin="round"/>
<path d="M7 6V26" stroke="currentColor" stroke-width="2" stroke-linejoin="round"/>
<path d="M16 6V26" stroke="currentColor" stroke-width="2" stroke-linejoin="round"/>
<path d="M21 6V26" stroke="currentColor" stroke-width="2" stroke-linejoin="round"/>
<path d="M20 6V26" stroke="currentColor" stroke-width="2" stroke-linejoin="round"/>
<path d="M8 6V26" stroke="currentColor" stroke-width="2" stroke-linejoin="round"/>
<path d="M25 6V26" stroke="currentColor" stroke-width="2" stroke-linejoin="round"/>
<path d="M12 6V26" stroke="currentColor" stroke-width="2" stroke-linejoin="round"/>
</svg>`;
